import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/PageContent.scss';

export default function PageContent({
    children,
    className,
    ...props
}) {
    const classes = classNames(styles.content, className);

    return (
        <div {...props} className={classes}>
            <div className={styles.inner}>
                {children}
            </div>
        </div>
    );
}

PageContent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
